export enum DocumentApprovalState {
  WaitingForApproval= 0,
  ApprovedForUploaded = 1,
  Uploaded = 2,
  Denied = 3,

}
